import React from 'react';
import SVG from 'react-inlinesvg';
import { connect } from 'react-redux';

import './index.css';
import { toggleFormsModal } from '../../actions';
import FormIdea from '../../components/formIdea';
import TechnologiesCarousel from '../../components/technologiesCarousel';
import laptop from '../../images/web/laptop-min.png';
import laptop2 from '../../images/web/laptop2-min.png';
import sites from '../../images/web/sites.svg';
import web from '../../images/web/web.svg';
import crm from '../../images/web/crm.svg';
import analysis from '../../images/web/analysis.svg';
import roja from '../../images/web/interface.svg';
import code from '../../images/web/code.svg';
import technologies from '../../images/web/technologies.svg';
import business from '../../images/web/business.svg';
import adaptive from '../../images/web/adaptive.svg';

class Web extends React.Component {

  render() {

    return (
      <div className="web page">
        <div className="web__preview">
          <div className="mobile__preview__footer">
            <div className="mobile__preview__footer__wrapper">
              <span className="mobile__preview__footer__leo">CREATIVE PROJECT IS LEO</span>
              <div className="mobile__preview__footer__links">
                <a target="_blank" rel="noopener noreferrer" href="https://www.behance.net/leotrado8901" className="mobile__preview__footer__social">behance</a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.ru/leotrado/" className="mobile__preview__footer__social">pinterest</a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2Fgroups%2F249633105595577%2F" className="mobile__preview__footer__social">facebook</a>
              </div>
            </div>
          </div>
          <div className="web__preview__info">
            <h1>web</h1>
            <div className="subtitle">{localStorage.getItem('lang') == 'ru'? 'Разработка web проектов любой сложности':'Development of web projects of any complexity'}</div>
          </div>
        </div>
        <div className="web__development">
          <img className="web__development__laptop" src={laptop} alt="" />
          <div className="web__development__container">
            <div className="web__development__item">
              <SVG src={sites} className="web__development__item__img" />
              <h3 className="web__development__item__title">{localStorage.getItem('lang') == 'ru'? 'Сайты':'Websites'}</h3>
              <p className="web__development__item__description">
              {localStorage.getItem('lang') == 'ru'? 'Разработка сайтов от идеи до готового продукта. Также выполняем редизайн, развитие и техподдержку уже запущенных проектов.':
              'Website development from idea to finished product. We also carry out redesign, development and technical support of already launched projects.'}
                
              </p>
            </div>
            <div className="web__development__item">
              <SVG src={web} className="web__development__item__img" />
              <h3 className="web__development__item__title">{localStorage.getItem('lang') == 'ru'? 'Web-приложения':'Web-applications'}</h3>
              <p className="web__development__item__description">
              {localStorage.getItem('lang') == 'ru'? 'Создание и разработка любых нестандартных веб-приложений как в области дизайна так и функционала приложения.':
              'Creation and development of any non-standard web applications both in the field of design and application functionality.'}
                
              </p>
            </div>
            <div className="web__development__item">
              <SVG src={crm} className="web__development__item__img" />
              <h3 className="web__development__item__title">{localStorage.getItem('lang') == 'ru'? 'CRM-системы':'CRM-systems'}</h3>
              <p className="web__development__item__description">
              {localStorage.getItem('lang') == 'ru'? 'Разработка CRM-систем для эффективной работы и автоматизации бизнеса.':
              'Development of CRM systems for efficient work and business automation.'}
                
              </p>
            </div>
          </div>
        </div>
        <div className="web__methods">
          <div className="web__methods__background" />
          <div className="web__methods__section">
            <div className="web__methods__item">
              <div>
                <SVG src={analysis} className="web__methods__item__icon" />
                <span className="web__methods__item__title">{localStorage.getItem('lang') == 'ru'? 'индивидуальность':'individuality'}</span>
              </div>
              <p className="web__methods__item__description">
              {localStorage.getItem('lang') == 'ru'? 'Есть много вариантов готовых систем, но большинство из них не всегда имеет нужные настройки. Нам важно показать вашу идею через дизайн проекта.':
              'There are many options for ready-made systems, but most of them do not always have the necessary settings. It is important for us to show your idea through the design of the project.'}
                
              </p>
            </div>
            <div className="web__methods__item">
              <div>
                <SVG src={roja} className="web__methods__item__icon" />
                <span className="web__methods__item__title">{localStorage.getItem('lang') == 'ru'? 'простой интерфейс':'simple interface'}</span>
              </div>
              <p className="web__methods__item__description">
              {localStorage.getItem('lang') == 'ru'? 'Простой интерфейс интуитивно понятен и удобен, при работе не отвлекает от поставленной задачи.':
              'The simple interface is intuitive and convenient, while working does not distract from the task.'}
                
              </p>
            </div>
            <div className="web__methods__item">
              <div>
                <SVG src={code} className="web__methods__item__icon" />
                <span className="web__methods__item__title">{localStorage.getItem('lang') == 'ru'? 'качественный код':'quality code'}</span>
              </div>
              <p className="web__methods__item__description">
              {localStorage.getItem('lang') == 'ru'? 'Минимизирует ошибки системы, гарантирует сохранность данных, и обеспечивает быструю работу системы.':
              'Minimizes system errors, guarantees data safety, and ensures fast system operation.'}
                
              </p>
            </div>
          </div>
          <div className="web__methods__info">
            <h2 className="web__methods__info__title">{localStorage.getItem('lang') == 'ru'? 'Разработка сайтов и web-приложений любой сложности':'Development of sites and web applications of any complexity'}</h2>
            <span className="web__methods__underline"></span>
            <p>
            {localStorage.getItem('lang') == 'ru'? 'Создавая продукт объединяем в нем современные тренды веб-дизайна и программирования, воплощаем в жизнь идеи заказчика.':
            'Creating a product we combine the modern trends of web design and programming in it, we realize the ideas of the customer.'}
            </p>
            <p>
            {localStorage.getItem('lang') == 'ru'? 'Разрабатываем сайты и серверные приложения. Автоматизируем бизнес-процессы, упрощаем использование продукта, осуществляем техническое сопровождение.':
            'We develop sites and server applications. We automate business processes, simplify the use of the product, and provide technical support.'}
              
            </p>
          </div>
        </div>

          <TechnologiesCarousel
            tech="web"
            redirectToPortfolio={() => this.props.history.push('/portfolio')} />

          <div className="web__technologies">
            <div className="web__technologies__wrapper">
              <img
                src={laptop2}
                alt=""
                className="web__technologies__laptop" />
            </div>
            <div className="web__technologies__wrapper">
              <div className="web__technologies__item">
                <SVG src={technologies} className="web__technologies__item__icon" />
                <h3 className="web__technologies__item__title">{localStorage.getItem('lang') == 'ru'? 'Современные технологии':'Modern technologies'}</h3>
                <p className="web__technologies__item__description">{localStorage.getItem('lang') == 'ru'? 'Позволяют создавать проекты быстро и качественно, без дополнительных затрат':
                'Allow you to create projects quickly and efficiently, at no additional cost'}</p>
              </div>
              <div className="web__technologies__item">
                <SVG src={adaptive} className="web__technologies__item__icon" />
                <h3 className="web__technologies__item__title">{localStorage.getItem('lang') == 'ru'? 'Адаптивная верстка':'Adaptive layout'}</h3>
                <p className="web__technologies__item__description">
                {localStorage.getItem('lang') == 'ru'? 'Приложение всегда хорошо выглядит на любом типе носителя, будь то мобильный телефон, планшет или большой монитор.':
                'The application always looks good on any type of media, be it a mobile phone, tablet or large monitor.'}</p>
              </div>
              <div className="web__technologies__item">
                <SVG src={business} className="web__technologies__item__icon" />
                <h3 className="web__technologies__item__title">{localStorage.getItem('lang') == 'ru'? 'Решение бизнес-задач':'Business Solution'}</h3>
                <p className="web__technologies__item__description">
                {localStorage.getItem('lang') == 'ru'? 'Проектируем системы для решения конктретно ваших бизнес-задач. Автоматизируем и налаживаем бизнес-процессы.':
                'We design systems to solve your business problems specifically. We automate and establish business processes.'}</p>
              </div>
            </div>
          </div>

        <FormIdea theme="dark" />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFormsModal: (flag, tab) => dispatch(toggleFormsModal(flag, tab))
  }
}

export default connect(null, mapDispatchToProps)(Web)



// WEBPACK FOOTER //
// ./src/pages/web/index.jsx